window.InifECShared.factory("FacebookService", [
  "$q",
  "$http",
  "$timeout",
  "$rootScope",
  "$FB",
  function ($q, $http, $timeout, $rootScope, $FB) {
    var factory = this;

    // --------------------------------
    // 以Facebook註冊
    // --------------------------------
    var applyWithFacebook = function (scope) {
      var defer = $q.defer();
      if (!scope) {
        scope = "public_profile, email";
      }

      $FB.login(
        function (resp) {
          $rootScope.$apply(function () {
            if (resp.authResponse) {
              var uid = resp.authResponse.userID,
                accesstoken = resp.authResponse.accessToken;

              $http({
                url: SECURE_INIFEC_URL + "/FacebookAction.do",
                method: "POST",
                params: {
                  op: "register",
                  uid: uid,
                  accesstoken: accesstoken,
                  createfrommobile:
                    window.isMobile || window.location.protocol == "file:",
                },
                withCredentials: true,
              })
                .success(function (data) {
                  if (data.error) {
                    defer.reject(data.error);
                  } else {
                    defer.resolve(data);
                  }
                })
                .error(function (data, status, headers, config) {
                  defer.reject(data);
                  console.error(
                    "[App4Fx Error] : UserFactory.applyWithFacebook request error."
                  );
                  console.error("status : " + status);
                });
            } else {
              defer.reject({
                msgid: -1,
                msg: "與Facebook連結發生錯誤!",
              });
            }
          });
        },
        {
          scope: scope,
        }
      );

      return defer.promise;
    };

    // --------------------------------
    // 以Facebook登入
    // --------------------------------

    var loginWithFacebook = function (popup_window, scope) {
      var defer = $q.defer();
      if (!scope) {
        scope = "public_profile, email";
      }

      //網頁版登入使用fb官方api登入
      //手機版如果在line中瀏覽器無法正常登入，因此使用手動登入流程方式，靠後端回傳登入網址
      if (popup_window) {
        $FB.login(
          function (resp) {
            $rootScope.$apply(function () {
              if (resp.authResponse) {
                var uid = resp.authResponse.userID,
                  accesstoken = resp.authResponse.accessToken;

                loginWithFBAccesstoken(uid, accesstoken).then(
                  function (result) {
                    defer.resolve(result);
                  },
                  function (error) {
                    defer.reject(error);
                    console.error(
                      "[App4Fx Error] : FacebookService.loginWithFacebook request error."
                    );
                    console.error("error : " + error);
                  }
                );
              } else {
                defer.reject({
                  msgid: -1,
                  msg: "與Facebook連結發生錯誤!",
                });
              }
            });
          },
          {
            scope: scope,
          }
        );
      } else {
        $http({
          url: SECURE_INIFEC_URL + "/FacebookAction.do",
          method: "POST",
          data: $.param({
            op: "getRedirectUrl",
          }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          withCredentials: true,
        })
          .success(function (data) {
            if (data) {
              if (data.error) {
                defer.reject(data.error);
              } else {
                location.href = data + "&response_type=token";
              }
            } else {
              defer.reject();
            }
          })
          .error(function (data, status, headers, config) {
            defer.reject(data);
            console.error(
              "[App4Fx Error] : FacebookService.sendViewProductPixel error."
            );
            console.error("status : " + status);
          });
      }

      return defer.promise;
    };

    // --------------------------------
    // 用拿到的Facebook token登入
    // --------------------------------
    var loginWithFBAccesstoken = function (uid, accesstoken) {
      var defer = $q.defer();

      $http({
        url: SECURE_INIFEC_URL + "/FacebookAction.do",
        method: "POST",
        params: {
          op: "register",
          uid: uid,
          accesstoken: accesstoken,
        //   createfrommobile: window.isMobile || IS_IN_APP,
        },
        withCredentials: true,
      })
        .success(function (data) {
          if (data.error) {
            defer.reject(data.error);
          } else {
            defer.resolve(data);
          }
        })
        .error(function (data, status, headers, config) {
          defer.reject(data);
          console.error(
            "[App4Fx Error] : FacebookService.loginWithFBAccesstoken request error."
          );
          console.error("status : " + status);
        });

      return defer.promise;
    };

    /*==========================
            Members
        ==========================*/

    /*==========================
            Methods
        ==========================*/

    /** 以Facebook註冊 */
    factory.applyWithFacebook = applyWithFacebook;
    /** 以Facebook登入 */
    factory.loginWithFacebook = loginWithFacebook;
    /** 用拿到的Facebook token登入 */ 
    factory.loginWithFBAccesstoken = loginWithFBAccesstoken;


    /*==========================
            init
        ==========================*/

    return factory;
  },
]);
